// @mui
import { GlobalStyles as MUIGlobalStyles } from '@mui/material';

// ==============================|| GLOBAL STYLES ||============================== //

export default function GlobalStyles({ theme }) {
  const inputGlobalStyles = (
    <MUIGlobalStyles
      styles={{
        '*': {
          boxSizing: 'border-box',
        },
        html: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch',
        },
        
        body: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          backgroundColor: theme.palette.color.background,
          '&::-webkit-scrollbar': {
            width: '10px',
            backgroundColor: 'rgb(241, 241, 241)'
          },

          '&::-webkit-scrollbar-corner ': {
            borderRadius: '10px',
            backgroundColor: 'rgb(153, 153, 153)'
          },
  
          '&::-webkit-scrollbar-track': {
            WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,.3)',
            boxShadow: 'inset 0 0 6px rgba(0,0,0,.3)',
          },
  
          '&::-webkit-scrollbar-thumb': {
            outline: 'none',
            borderRadius: '30px',
            backgroundColor: 'rgb(153, 153, 153)',
          }
        },
        '#scroll-smoother-container': {
          width: '100%',
          minHeight: '100%',
        },
        '#root': {
          width: '100%',
          height: '100%',
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
          },
        },
        img: {
          display: 'block',
          maxWidth: '100%',
        },
        ul: {
          margin: 0,
          padding: 0,
        },

        /* 水印 */
        ".cover": {
          position: 'absolute',
          top:0,
          overflow: 'hidden'
        },
        "#baifen": {
          position: 'absolute',
          float: 'right',
          fontSize: '12px',
          color: '#DDD',
          ".keepbtn": {
            display: 'inline-block',
            width: '16px',
            height: '16px',
            padding: '2px 2px 0px 3px',
            backgroundColor: 'red',
          }
        },
        /* 水印 */

        ':where(.css-dev-only-do-not-override-1261szd).ant-picker-dropdown .ant-picker-cell .ant-picker-cell-inner': {
          minWidth: '36px',
          minHeight: '36px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          alignSelf: 'center',
          borderRadius: 99,
        },
        ':where(.css-dev-only-do-not-override-1261szd).ant-picker-dropdown .ant-picker-cell::before': {
          height: '36px',
        },
        ':where(.css-dev-only-do-not-override-1261szd).ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-end) .ant-picker-cell-inner': {
          borderStartStartRadius: 99,
          borderEndStartRadius: 99,
        },
        ':where(.css-dev-only-do-not-override-1261szd).ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-start) .ant-picker-cell-inner': {
          borderStartEndRadius: 99,
          borderEndEndRadius: 99,
        },
        ':where(.css-dev-only-do-not-override-1261szd).ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before': {
          borderRadius: 99,
        },
        ':where(.css-dev-only-do-not-override-1261szd).ant-picker-range .ant-picker-range-separator': {
          padding: 0,
        },
        ':where(.css-dev-only-do-not-override-1261szd).ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-selected:not(.ant-picker-cell-disabled) .ant-picker-cell-inner, :where(.css-dev-only-do-not-override-1261szd).ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-disabled) .ant-picker-cell-inner, :where(.css-dev-only-do-not-override-1261szd).ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-disabled) .ant-picker-cell-inner': {
          background: theme.palette.primary.main,
        },
        // ':where(.css-dev-only-do-not-override-76aqpv).ant-picker-dropdown .ant-picker-cell .ant-picker-cell-inner': {
        //   minWidth: 32,
        //   height: 32,
        // },
        '.ant-picker-suffix, .ant-picker-clear': { 
          fontSize: 18,
          '& svg': {
            fill: 'rgb(114, 114, 114)',
            color: 'rgb(114, 114, 114)',
          }
        },
        '.ant-picker.ant-picker-focused': { 
          boxShadow: 'none',
          '&:after': {
            content: '""',
            display: 'block',
            position: 'absolute',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            width: '100%',
            height: '100%',
            border: `2px solid ${theme.palette.primary.main}`,
            boxSizing: 'border-box'
          }
        },


        "@keyframes toRightFromLeft": {
          "49%": {
            transform: "translate(100%)"
          },
          "50%": {
            opacity: 0,
            transform: "translate(-100%)"
          },
          "51%": {
            opacity: 1,
          }
        },
        "@keyframes toLeftFromRight": {
          "49%": {
            opacity: 0,
            transform: "translate(-100%)"
          },
          "50%": {
            transform: "translate(100%)"
          },
          "51%": {
            opacity: 1,
          }
        },

        "@keyframes moving-left-right-one": {
          "49%": {
            transform: "translateX(0) translateY(0)"
          },
          "40%": {
            transform: "translateX(50px) translateY(-200px)"
          },
          "75%": {
            transform: "translateX(800px)"
          },
          "100%": {
            transform: "translateY(0) translateX(0)"
          }
        },

        "@keyframes moving-left-right-two": {
          "49%": {
            transform: "translateX(0) translateY(0)"
          },
          "40%": {
            transform: "translateX(-50px) translateY(200px)"
          },
          "75%": {
            transform: "translateX(-500px)"
          },
          "100%": {
            transform: "translateY(0) translateX(0)"
          }
        },

        "@keyframes moving-left-right-three": {
          "0%": {
            transform: "translateX(0) translateY(0)"
          },
          "40%": {
            transform: "translateX(100px) translateY(-200px)"
          },
          "75%": {
            transform: "translateX(-500px)"
          },
          "100%": {
            transform: "translateY(0) translateX(0)"
          }
        },

        "@keyframes fadeInRight": {
          "0%": {
            opacity: 0,
            transform: "translateX(-20px)"
          },
          "100%": {
            opacity: 1,
            transform: "translateX(0)"
          }
        },

        "@keyframes fadeInUp": {
          "0%": {
            opacity: 0,
            transform: "translateY(20px)"
          },
          "100%": {
            opacity: 1,
            transform: "translateY(0)"
          }
        },

        "@keyframes fadeInDown": {
          "0%": {
            opacity: 0,
            transform: "translateY(-20px)"
          },
          "100%": {
            opacity: 1,
            transform: "translateY(0)"
          }
        },

        "@keyframes fadeOutDown": {
          "0%": {
            opacity: 1,
            transform: "translateY(0px)"
          },
          "100%": {
            opacity: 0,
            transform: "translateY(-20px)"
          }
        },


        "@keyframes shine": {
          "100%": {
            left: "125%"
          }
        },
      }}
    />
  );

  return inputGlobalStyles;
}
